export default __webpack_public_path__ + "static/media/b1.ec96c213.webp";